import {
  HospitalityRoomStatus,
  ROOM_STATUS_CONFIG,
} from '../constants/roomStatuses'
import type { RoomStatusConfig } from '../constants/roomStatuses'
import { WAKEUP_DISPLAY_CONFIG } from '../constants/wakeupStatuses'
import type { WakeupDisplayConfig } from '../constants/wakeupStatuses'
import type { WakeupDisplayStatus } from '../types/wakeup'

/**
 * Get the display configuration for a room status code.
 * Returns label, colorPalette, bg, bgDark, and border values.
 */
export const getRoomStatusConfig = (
  status: HospitalityRoomStatus,
): RoomStatusConfig => {
  return (
    ROOM_STATUS_CONFIG[status] ??
    ROOM_STATUS_CONFIG[HospitalityRoomStatus.DIRTY]
  )
}

/**
 * Get the display configuration for a wake-up call display status.
 * Returns label and colorPalette for badge rendering.
 */
export const getWakeupDisplayConfig = (
  displayStatus: WakeupDisplayStatus,
): WakeupDisplayConfig => {
  return WAKEUP_DISPLAY_CONFIG[displayStatus] ?? WAKEUP_DISPLAY_CONFIG.scheduled
}
